<!-- Certifications component -->
<script>
  import { Col, Row, Container } from "sveltestrap";

  export let certificationData = {};
  const { title, description, certifications_list } = certificationData;
</script>

<!--START TEAM-->
<section class="section pt-4 common-section" id="certifications">
  <Container>
    <Row>
      <Col lg={{ size: 8, offset: 2 }}>
        <h1 class="section-title text-center">{title}</h1>
        <div class="section-title-border mt-3" />
        <p class="section-subtitle text-muted text-center font-secondary pt-4">
          {description}
        </p>
      </Col>
    </Row>
    <Row class="mt-4">
      {#each certifications_list as list}
        <Col lg="{{ size: 2, offset: 1 }}" sm="2">
          <div class="team-box text-center hover-effect">
            <div class="team-wrapper">
              <div class="team-member">
                <img alt="" src={list.profile} class="img-fluid rounded" />
              </div>
            </div>
            <h4 class="team-name">{list.name}</h4>
            <p class="text-uppercase team-designation">{list.designation}</p>
          </div>
        </Col>
      {/each}
    </Row>
  </Container>
</section>
<!--END TEAM-->

